/**
 * @deprecated This file is being refactored into smaller modules.
 * Please import from 'services/workflow' instead.
 */

// Import before exports
import { WorkflowAPIService, SimpleWorkflowAPIService, DocumentService } from './workflow';

// Re-export everything from the new services
export * from './workflow';

// For backward compatibility, export the main functions that were directly exported

// Verwende den neuen SimpleWorkflowAPIService anstelle des alten WorkflowAPIService
export const getWorkflows = async (userId?: string, params?: Record<string, any>) => {
  // TypeScript-Cast, um zu erzwingen, dass der Compiler versteht, dass die Funktion 2 Parameter akzeptiert
  const getWorkflowsFunc = SimpleWorkflowAPIService.getWorkflows as unknown as (userId?: string, params?: Record<string, any>) => Promise<any>;
  return getWorkflowsFunc(userId, params);
};
export const getWorkflowById = SimpleWorkflowAPIService.getWorkflowById;
export const createWorkflow = SimpleWorkflowAPIService.createWorkflow;
export const addDocumentToWorkflow = SimpleWorkflowAPIService.addDocumentToWorkflow;
export const updateWorkflowStatus = SimpleWorkflowAPIService.updateWorkflowStatus;

// Die alte API wird noch für diese Funktionen beibehalten, bis sie im SimpleWorkflowAPIService implementiert sind
export const getPaymentsForWorkflow = WorkflowAPIService.getPaymentsForWorkflow;

// Export the original function which is used directly in some places
export const directLoadDocumentValues = DocumentService.loadDocumentValues;